var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-header" }, [
        _c(
          "div",
          [
            _c(
              "el-radio-group",
              {
                staticStyle: { "margin-bottom": "20px" },
                on: { change: _vm.handleTabChange },
                model: {
                  value: _vm.tabPosition,
                  callback: function($$v) {
                    _vm.tabPosition = $$v
                  },
                  expression: "tabPosition"
                }
              },
              [
                _c("el-radio-button", { attrs: { label: "在职" } }, [
                  _vm._v("在职")
                ]),
                _c("el-radio-button", { attrs: { label: "离职" } }, [
                  _vm._v("离职")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": _vm.headerStyle,
            "row-class-name": _vm.tableRowClassName
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              align: "center",
              width: "80",
              type: "index"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "姓名",
              align: "center",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.name || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "idCard",
              label: "身份证",
              align: "center",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.idCard || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: "电话",
              align: "center",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.phone || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "area", label: "区域园区", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.region || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "personnel_category_hc",
              label: "人员类别",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticStyle: { color: "#219aff" } }, [
                      _vm._v(_vm._s(scope.row.personnel_category_hc || "-"))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "position", label: "计费岗位", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.position || "-"))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "position_duties",
              label: "岗位职责",
              align: "center",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.position_duties &&
                    scope.row.position_duties.length
                      ? _c(
                          "div",
                          { staticClass: "tag-container" },
                          _vm._l(
                            typeof scope.row.position_duties === "string"
                              ? scope.row.position_duties.split(",")
                              : scope.row.position_duties,
                            function(skill, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticClass: "skill-tag",
                                  attrs: { size: "small", type: "success" }
                                },
                                [_vm._v(_vm._s(skill))]
                              )
                            }
                          ),
                          1
                        )
                      : _c("div", [_vm._v("-")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "position_nature",
              label: "岗位性质",
              align: "center",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.position_nature || "-"))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "备注", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.remark || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              align: "center",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.status || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      {
                        on: {
                          command: function(command) {
                            return _vm.handleCommand(command, scope.row)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _vm._v("\n            更多操作 "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "edit",
                                  disabled: !_vm.canEdit
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "delete",
                                  disabled:
                                    !_vm.isAuthorizedUser() ||
                                    scope.row.status !== "离职" ||
                                    !_vm.canEdit
                                }
                              },
                              [_vm._v("删除")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "history" } },
                              [_vm._v("历史记录")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageParams.skip,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageParams.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.isEdit ? "编辑计费HC人员" : "添加计费HC人员",
            visible: _vm.dialogVisible,
            direction: "rtl",
            size: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "employeeForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证", prop: "id_card" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.id_card,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "id_card", $$v)
                          },
                          expression: "form.id_card"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电话", prop: "phone" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域园区", prop: "region" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          on: { focus: _vm.handleSelectFocus },
                          model: {
                            value: _vm.form.region,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "region", $$v)
                            },
                            expression: "form.region"
                          }
                        },
                        _vm._l(_vm.campusOptions, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: Object.values(item)[0],
                              value: Object.values(item)[0]
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "人员类别",
                        prop: "personnel_category_hc"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.personnel_category_hc,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "personnel_category_hc", $$v)
                            },
                            expression: "form.personnel_category_hc"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "计费HC", value: "计费HC" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "计费岗位", prop: "position" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.position,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "position", $$v)
                            },
                            expression: "form.position"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "网络运维工程师",
                              value: "网络运维工程师"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "服务器运维工程师(5*8)",
                              value: "服务器运维工程师(5*8)"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "IT资产管理员",
                              value: "IT资产管理员"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "服务器工程师",
                              value: "服务器工程师"
                            }
                          }),
                          _c("el-option", {
                            attrs: { label: "网络工程师", value: "网络工程师" }
                          }),
                          _c("el-option", {
                            attrs: { label: "资产管理员", value: "资产管理员" }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "C_服务器自维保工程师",
                              value: "C_服务器自维保工程师"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "C_服务器7*24工程师",
                              value: "C_服务器7*24工程师"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "C_IT资产管理员",
                              value: "C_IT资产管理员"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "C_网络运维工程师",
                              value: "C_网络运维工程师"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "IT运维工程师",
                              value: "IT运维工程师"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "IT运维岗-初级",
                              value: "IT运维岗-初级"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "IT运维岗-中级",
                              value: "IT运维岗-中级"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "IT运维岗-高级",
                              value: "IT运维岗-高级"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "IT现场运维管理岗",
                              value: "IT现场运维管理岗"
                            }
                          }),
                          _c("el-option", {
                            attrs: { label: "综合支持岗", value: "综合支持岗" }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "FRE运营开发岗-初级",
                              value: "FRE运营开发岗-初级"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "FRE运营开发岗-中级",
                              value: "FRE运营开发岗-中级"
                            }
                          }),
                          _c("el-option", {
                            attrs: {
                              label: "FRE运营开发岗-高级",
                              value: "FRE运营开发岗-高级"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "岗位职责", prop: "position_duties" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.position_duties,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "position_duties", $$v)
                            },
                            expression: "form.position_duties"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "网络", value: "网络" }
                          }),
                          _c("el-option", {
                            attrs: { label: "服务器", value: "服务器" }
                          }),
                          _c("el-option", {
                            attrs: { label: "资产", value: "资产" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "岗位性质", prop: "position_nature" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.position_nature,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "position_nature", $$v)
                            },
                            expression: "form.position_nature"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "5*8小时", value: "5*8小时" }
                          }),
                          _c("el-option", {
                            attrs: { label: "7*24小时", value: "7*24小时" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: "3" },
                        model: {
                          value: _vm.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.status,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "在职", value: "在职" }
                          }),
                          _c("el-option", {
                            attrs: { label: "离职", value: "离职" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "20px" }
                },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消")
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("history-dialog", {
        attrs: {
          visible: _vm.historyDialogVisible,
          "employee-id": _vm.currentEmployeeId
        },
        on: {
          "update:visible": function($event) {
            _vm.historyDialogVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }